module.exports = __webpack_public_path__ + "static/media/ionic-ios-minus-circle-outline.e01253e0.svg";